import React, { useEffect, useState } from 'react'
import { Box, Checkbox, Input, Typography } from '@mui/joy'
import { useSettingContextInComponent, useSettingsContext } from 'src/mtska-frontend-app-scaffolding';
import { useTranslation, Trans } from 'react-i18next';
import JSONPretty from 'react-json-pretty';
import { Icon } from 'src/mtska-frontend-app-component/assets';
import { Button } from '../Button';

import SaveNamedColumnViewControls from './SaveNamedColumnViewControls';

const ColumnsPanel = (props) => {
    const { drawable, visibilityModel } = useSettingContextInComponent(props.dataProviderName);
    const { setSettingsKey, settings } = useSettingsContext(props.dataProviderName);
    const [searchKey, setSearchKey] = useState()
    const [showTechNames, setShowTechNames] = useState()
    return (
        drawable &&
        <Box className="mtska-filter-panel" sx={{
            display: 'grid',
            gridTemplateRows: '40px 60px minmax(0, 1fr) auto',
            height: '100vh',
            margin: '0 10px'
        }}>
            <Typography
                level="title-md"
                sx={{
                    margin: 0,
                    lineHeight: '40px',
                    borderBottom: '2px solid',
                    borderColor: 'divider',
                    fontWeight: 600,
                }}
            >
                <Trans
                    i18nKey="columnManagement"
                    components={{ light: <span style={{ fontWeight: 200 }} /> }}
                />
            </Typography>
            <Button icon="faCog" size="small" style={{ position: 'absolute', backgroundColor: "transparent !important", color: "var(--neutral-500) !important", top: '2px', right: '20px', padding: '0 !important' }} onClick={() => setShowTechNames(!showTechNames)} />
            <ColumnHeader searchKey={searchKey} setSearchKey={setSearchKey} />

            <div className='columnRowsScroller' style={{ overflowY: 'scroll' }}>
                {/* <JSONPretty data={props.columns} className='json-wrapper' />
                <JSONPretty data={visibilityModel} className='json-wrapper' /> */}
                <div className='columnRows'>
                    {props.columns && props.columns
                        .filter(column => column.field !== undefined)
                        .map(column => (
                            <ColumnRow column={column} visibilityModel={visibilityModel} setSettingsKey={setSettingsKey} searchKey={searchKey} showTechNames={showTechNames} />
                        ))
                    }
                </div>
            </div>

            <Box
                sx={{
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    pt: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                }}
            >
                <ColumnRowAction columns={props.columns} visibilityModel={visibilityModel} setSettingsKey={setSettingsKey} />
                {!props.isManaged && (
                    <SaveNamedColumnViewControls
                        layout="panel"
                        disabled={false}
                        columnOrder={settings?.columnOrder}
                        visibilityModel={settings?.visibilityModel}
                        tableViewCustomRecipes={settings?.tableViewCustomRecipes ?? []}
                        setSettingsKey={setSettingsKey}
                        sx={{ marginBottom: '20px' }}
                    />
                )}
            </Box>
        </Box>
    )
}


const ColumnHeader = ({ searchKey, setSearchKey }) => {
    const { t } = useTranslation();

    return (<div className="columns-header" style={{
        padding: '10px',
        fontWeight: '300',
        fontSize: '13px',
        lineHeight: '30px',
        color: 'var(--joy-palette-neutral-700, #333)',
        borderBottom: '1px solid var(--joy-palette-divider, #666)',
    }}>
        <div>
            <Input
                id={'search'}
                type={'text'}
                name={'search'}
                value={searchKey}
                variant="outlined"
                autoComplete="off"
                className="form-element-field"
                placeholder={t('search_columns_by_name')}
                startDecorator={<Icon icon={'faMagnifyingGlass'} />}

                onChange={(e) => setSearchKey(e.target.value)}
            />
        </div>
    </div>)
}

const ColumnRow = ({ column, visibilityModel, setSettingsKey, searchKey, showTechNames }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => { setIsLoading(false) }, [visibilityModel]);

    const handleChangeVisibility = (field) => {
        const newVisibilityModel = { ...visibilityModel, __check__: true };
        newVisibilityModel[field] = !newVisibilityModel[field];
        setSettingsKey('visibilityModel', newVisibilityModel);
        setIsLoading(true);
    }

    const label = t(column.field.replace('_related_', '').replace('_readable', '').replace('_numeric', ''));
    const field = column.field;

    if (searchKey && !(label.toLowerCase()).includes(searchKey.toLowerCase())) return;

    let labelComponent;
    if (!showTechNames) {
        labelComponent = <Box sx={{ display: 'flex', flexDirection: 'column' }}><p style={{ margin: '0' }}>{label}</p></Box>
    } else {
        labelComponent = <Box sx={{ display: 'flex', flexDirection: 'column' }}><p style={{ margin: '0' }}>{label}</p><span style={{ fontSize: '10px', fontWeight: '200', color: 'var(--neutral-500)' }}>{field}</span></Box>
    }

    return (<div className="column-row" style={{
        padding: '10px',
        borderBottom: '1px solid var(--joy-palette-divider, #ccc)',
    }}>
        <div>
            <Checkbox
                key={column.field}
                label={labelComponent}
                checked={visibilityModel[column.field] ? visibilityModel[column.field] : false}
                onChange={() => {
                    handleChangeVisibility(column.field);
                }}

                loading={isLoading}
                id={column.field}
                type={'checkbox'}
                name={column.field}
                variant="outlined"
                autoComplete="off"
                sx={{ fontSize: '14px' }}

                readOnly={column.hideable === false ? true : false}
            />
        </div>
    </div>)
}
const ColumnRowAction = ({ columns, visibilityModel, setSettingsKey }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => { setIsLoading(false) }, [visibilityModel]);

    const all = (value) => {
        const newVisibilityModel = { __check__: true }
        Object.entries(columns).forEach(([k, column]) => {
            newVisibilityModel[column.field] = value;
        });

        setSettingsKey('visibilityModel', newVisibilityModel)
        setIsLoading(true);
    }

    return (<div className="column-show-button" style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
        <Button
            onClick={() => all(true)}
            loading={isLoading}
            icon={'faEye'}
            style={{ flex: 1, height: '26px', fontWeight: '14px' }}
            size='sm'
            variant={'outlined'}
        >
            {t('show_all')}
        </Button>
        <Button
            onClick={() => all(false)}
            loading={isLoading}
            icon={'faEyeSlash'}
            style={{ flex: 1, height: '26px', fontWeight: '14px' }}
            size='sm'
            variant={'outlined'}
        >
            {t('hide_all')}
        </Button>
    </div>)
}

export default ColumnsPanel;